import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';
import { AuthGuard, CmsConfig, DeferLoadingStrategy, I18nModule, provideConfig, UrlModule } from '@spartacus/core';
import { CmsPageGuard, MediaModule, PageLayoutComponent } from '@spartacus/storefront';
import { LaunchDialogModalLayoutConfig } from 'src/app/dialog/custom-launch-dialog-config';
import { SharedModule } from 'src/app/shared/shared.module';
import { ParagraphComponent } from '../../paragraph/paragraph.component';
import { NotifyMeModule } from '../../product/notify-me/notify-me.module';
import { ProductImageModalModule } from '../../product/product-image-modal/product-image-modal.module';
import { TooltipIconModule } from '../../tooltip-icon/tooltip-icon.module';
import { TooltipTextModule } from '../../tooltip-text/tooltip-text.module';
import { AddToCartModule } from '../add-to-cart/add-to-cart.module';
import { OrderFormSummaryComponent } from './order-form-summary/order-form-summary.component';
import { OrderFormComponent } from './order-form.component';

@NgModule({
  imports: [
    CommonModule,
    UrlModule,
    I18nModule,
    AddToCartModule,
    MatDividerModule,
    MediaModule,
    MatFormFieldModule,
    MatInputModule,
    SharedModule,
    ReactiveFormsModule,
    TooltipIconModule,
    TooltipTextModule,
    NotifyMeModule,
    ProductImageModalModule,
    MatIconModule,
    RouterModule.forChild([
      {
        path: 'product/:code/:name/order-form',
        canActivate: [AuthGuard, CmsPageGuard],
        component: PageLayoutComponent,
        data: { pageLabel: '/order-form' },
      },
    ]),
    OrderFormComponent,
    OrderFormSummaryComponent,
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ShimanoParagraphComponent: {
          component: ParagraphComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
        OrderFormSummaryDetails: {
          component: OrderFormSummaryComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
        OrderFormFlexComponent: {
          component: OrderFormComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    }),
    provideConfig({
      ...LaunchDialogModalLayoutConfig.OrderForm,
    }),
  ],
})
export class OrderFormModule {}
